export default "__VITE_ASSET__DLEyahcX__"